module.exports = __webpack_public_path__ + "static/img/warngif.90cb6e3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/view/image/warngif.gif
// module id = 90VR
// module chunks = 1